export const succesngonitplanes = {
    error: false,
    data: [
        {
            coverages: [
                {
                    detail: "Si tu inquilino incumple con el pago del arriendo y de la administración (si está incluida),  SURA te pagará el dinero correspondiente hasta 5 millones de pesos.",
                    isOptional: false,
                    name: "Canon de Arrendamiento",
                    order: 1,
                    price: 499800
                },
                {
                    detail: "Si tu inquilino incumple con el pago de los servicios públicos, cuando desocupe el inmueble o al final del contrato, SURA te reembolsará hasta 2 veces el valor del canon de arrendamiento.",
                    isOptional: true,
                    name: "Servicios públicos",
                    order: 2,
                    price: 83300
                },
                {
                    detail: "SURA te acompaña cuando necesites servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica.",
                    isOptional: true,
                    name: "Paquete de asistencias básicas",
                    order: 3,
                    price: 209020
                },
                {
                    detail: "SURA te acompañara hasta por 36 meses, para que el inquilino te haga entrega del inmueble.",
                    isOptional: false,
                    name: "Servicio de restitución del inmueble",
                    order: 4,
                    price: 0
                }
            ],
            planName: "Arma tu plan",
            price: 792120,
            productCode: "ARRENDAMIENTO_ArmaTuPlan"
        },
        {
            coverages: [
                {
                    detail: "SSi tu inquilino incumple con el pago del arriendo y de la administración (si está incluida),  SURA te pagará el dinero correspondiente hasta 5 millones de pesos.",
                    isOptional: false,
                    name: "Canon de Arrendamiento",
                    order: 1,
                    price: 499800
                },
                {
                    detail: "Si tu inquilino incumple con el pago de los servicios públicos, cuando desocupe el inmueble o al final del contrato, SURA te reembolsará hasta 2 veces el valor del canon de arrendamiento.",
                    isOptional: false,
                    name: "Servicios públicos",
                    order: 2,
                    price: 83300
                },
                {
                    detail: "SURA te acompañara hasta por 12 meses, para que el inquilino te haga entrega del inmueble.",
                    isOptional: false,
                    name: "Servicio de restitución del inmueble",
                    order: 4,
                    price: 0
                }
            ],
            planName: "Esencial",
            price: 583100,
            productCode: "ARRENDAMIENTO_PlanEsencial"
        },
        {
            coverages: [
                {
                    detail: "Si tu inquilino incumple con el pago del arriendo y de la administración (si está incluida),  SURA te pagará el dinero correspondiente hasta 5 millones de pesos.",
                    isOptional: false,
                    name: "Canon de Arrendamiento",
                    order: 1,
                    price: 499800
                },
                {
                    detail: "Si tu inquilino incumple con el pago de los servicios públicos, cuando desocupe el inmueble o al final del contrato, SURA te reembolsará hasta 2 veces el valor del canon de arrendamiento.",
                    isOptional: false,
                    name: "Servicios públicos",
                    order: 2,
                    price: 83300
                },
                {
                    detail: "SURA te acompaña cuando necesites servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica.",
                    isOptional: false,
                    name: "Paquete de asistencias básicas",
                    order: 3,
                    price: 209020
                },
                {
                    detail: "SURA te acompañara hasta por 18 meses, para que el inquilino te haga entrega del inmueble.",
                    isOptional: false,
                    name: "Servicio de restitución del inmueble",
                    order: 4,
                    price: 0
                }
            ],
            planName: "Plus",
            price: 792121,
            productCode: "ARRENDAMIENTO_PlanPlus"
        }
    ]
};